import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  tenant: null,
  tenantTemplate: null,
  apiIntegration: null
}

// Store
export const content = createSlice({
  name,
  initialState,
  reducers: {
    getTenant: (state, { payload }) => {
      const { template, ...tenant } = payload
      state.tenant = tenant
      state.tenantTemplate = template
    },
    updateTenantFeatures: (state, { payload }) => {
      state.tenant.features = payload
    },
    updateTenantLoginProviders: (state, { payload }) => {
      state.tenant.loginProviders = payload
    },
    updateTenantTemplate: (state, { payload }) => {
      state.tenantTemplate = payload
      state.tenant.baseTemplate = payload.pathToRoot
      state.tenant.templateSK = payload.sk
    },
    setApiIntegration: (state, { payload }) => {
      state.apiIntegration = payload.apiIntegration
    },
    removeApiIntegration: (state, { payload }) => {
      if (payload.tenantId === state.tenant.pk) {
        state.apiIntegration = null
      }
    },
    setHelixMigrationConfig: (state, { payload }) => {
      state.helixMigration = payload
    },
    toggleHelixConfigEnabled: (state, { payload }) => {
      state.helixMigration = payload
    },
    reset: () => ({ ...initialState })
  }
})

export const { getTenant, updateTenantFeatures, updateTenantTemplate, updateTenantLoginProviders, reset, setApiIntegration, setHelixMigrationConfig, toggleHelixConfigEnabled } = content.actions

export default content.reducer
